export const TEXT = 0;
export const BINDING = 1;

export const DECLARATION_SPLIT =
  /((?:'[^']*')*(?:(?:[^|']*(?:'[^']*')+[^|']*)+|[^|]+))|^$/g;
